/* eslint-disable no-shadow */
/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
import { roleIDs } from "src/config/constant";
import StorageService from "src/utils/Storage/storageService";

const checkPaymentLink = (leadId: any, tableData: Record<string, any>) => {
  if (
    tableData?.[leadId]?.proposalStatus === "MEF Submitted" &&
    tableData?.[leadId]?.funding === "self" &&
    tableData?.[leadId]?.paymentStatus !== "Success"
  ) {
    return true;
  }
  if (
    tableData?.[leadId]?.proposalStatus === "MEF Submitted" &&
    tableData?.[leadId]?.paymentStatus === "Short Premium"
  ) {
    return true;
  }
  return false;
};

const cancelAction = (leadData: any, leadId: any, tableData: any, user: any) => {
  if (leadData?.[leadId]?.coverType === "proportionate" || user.role === roleIDs.irm) {
    return false;
  }
  if (
    leadData?.[leadId]?.policyNo === null &&
    tableData?.[leadId]?.proposalStatus === "MEF Submitted"
  ) {
    return true;
  }

  return false;
};

const bucketBEMapping: Record<string, any> = {
  "UW WIP": "UW",
  "NB WIP": "NB",
  IRM: "IRM",
  PIC: "PIC",
  Close: "Close",
  Cancel: "Cancel"
};

const bucketFormType: Record<string, any> = {
  MEF: "MEF",
  BI: "BI",
  "Spark O/P": "SPARK"
};

/* eslint-disable security/detect-object-injection */
const dashboardOptions = (leadId: string, tableData: Record<string, any>, leadData: any) => {
  const user = StorageService.getFromLocalStorage("user");
  const options = {
    action: {
      "UW WIP": {
        enabled: user.role !== roleIDs.irm
      },
      "NB WIP": {
        enabled: true
      },
      IRM: {
        enabled: true
      },
      PIC: {
        enabled: user.role !== roleIDs.irm
      },
      Close: {
        enabled: user.role !== roleIDs.irm
      },
      Cancel: {
        enabled: cancelAction(leadData, leadId, tableData, user)
      },
      "Send Payment Link": {
        enabled: checkPaymentLink(leadId, tableData)
      }
    },
    formType: {
      MEF: {
        enabled: true
      },
      BI: {
        enabled: true
      },
      ...(user?.role !== roleIDs.irm && {
        "Spark O/P": {
          enabled: true
        }
      })
    }
  };
  return options;
};

const OPTIONS: Record<string, any> = {
  filterLoanStatus: ["In Progress", "Sanctioned", "Disbursed"],
  filterProposalStatus: ["In Progress", "MEF Submitted", "Cancel", "Inforce"],
  filterSparkDecision: [
    {
      code: "CLEAN_CASE",
      description: "Clean case"
    },
    {
      code: "REFERRED",
      description: "Referred"
    },
    {
      code: "REF_ADD_EVID",
      description: "Referred - additional evidence"
    }
  ],
  filterPaymentStatus: ["Success", "Short Premium", "Failure", "Pending"],
  policyTerm: Array.from({ length: 21 }, (_, index) => (index + 10).toString()),
  nationality: {
    RES: "Indian",
    PIO: "Person of Indian Origin (PIO)",
    NRI: "Non Resident Indian (NRI)"
  },
  searchToBeAppliedOn: [
    "mobile",
    "lifeinsurername",
    "solid",
    "applicationno",
    "loanaccno",
    "clcapplicationno"
  ],
  pafFileExtensionSupported: [".csv", ".xls", ".xlsx"],
  signatureExtensionSupported: [".svg", ".png", ".jpg", ".pdf", ".gif"]
};

// options for selecting number of rows
const rowsOptions = ({ tableDataLength: length, pageNo: currentPage }: any): number[] => {
  const rowsPerPage = [10, 20, 30, 40, 50];
  const finalRowsPerPage: any[] = [];
  rowsPerPage.forEach((limit) => {
    if (limit * currentPage < length || limit * currentPage - length < limit)
      finalRowsPerPage.push(limit);
  });
  return finalRowsPerPage;
};

const setUrlParam = (value: string) => {
  const url = new URL(window.location as unknown as string);
  url.searchParams.set("search", value);
  window.history.pushState(null, "", url.toString());
};

const removeUrlParam = (key: string) => {
  const url = new URL(window.location as unknown as string);
  url.searchParams.delete(key);
  window.history.pushState(null, "", url.toString());
};

enum PROPOSAL_STATUS {
  IN_PROGRESS = "In Progress",
  MEF_SUBMITTED = "MEF Submitted"
}

enum PROPOSER_BUCKET {
  IRM = "IRM",
  NBGO = "NB"
}

enum SOURCE {
  PHYSICAL = "PHYSICAL"
}

enum LOAN_STATUS {
  SANCTIONED = "Sanctioned",
  DISBURSED = "Disbursed",
  PENDING = "Pending"
}

const enterMEFJourney = (leadData: Record<string, any>) => leadData?.canEditMEF;

export {
  OPTIONS,
  rowsOptions,
  setUrlParam,
  removeUrlParam,
  dashboardOptions,
  bucketBEMapping,
  enterMEFJourney,
  PROPOSAL_STATUS,
  PROPOSER_BUCKET,
  SOURCE,
  LOAN_STATUS,
  bucketFormType
};
